module.exports = __webpack_public_path__ + "assets/img/VBS-icon.38d449e2.svg";